<template>
  <mapit-dialog :dialog="dialog" @close="close">
    <template v-slot:body>
      <v-row no-gutters>
        <v-col cols="12">
          <h3 class="title-print-and-upload mr-4">
            <v-icon class="mr-4 fa-light fa-print" />
            {{ $t(`honda.registration.after.signature.download_and_print.title`) }}
          </h3>
          <p class="subtitle-print-and-upload">
            {{ $t(`honda.registration.after.signature.download_and_print.subtitle`) }}
          </p>
        </v-col>
        <v-col class="d-flex justify-center" cols="12">
          <div v-if="contractHP">
            <a :href="contractHP.documentUrl" download>
              <v-img class="mx-auto" src="/images/print-hp.png" width="130"></v-img>
            </a>
          </div>
          <div v-if="contractSEPA">
            <a :href="contractSEPA.documentUrl" download>
              <v-img class="mx-auto" src="/images/print-sepa.png" width="130"></v-img>
            </a>
          </div>
          <div v-if="contractHM">
            <a :href="contractHM.documentUrl" download>
              <v-img class="mx-auto" src="/images/print-hm.png" width="130"></v-img>
            </a>
          </div>
        </v-col>
        <v-col cols="12">
          <v-divider class="divider my-8" />
          <h3 class="title-print-and-upload mr-4">
            <v-icon class="mr-4 fa-light fa-signature" />
            {{ $t(`honda.registration.after.signature.sign_and_print.title`) }}
          </h3>
          <p id="check-signed" class="subtitle-print-and-upload mt-5 d-flex justify-center">
            <v-checkbox
              data-cy="check-signed-physical-docs"
              v-model="signedDocs"
              :disabled="loading"
              :label="$t('honda.registration.after.signature.check_sign')"
              :success="signedDocs"
              class="my-0 check-signed"
              hide-details
              dense />
          </p>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer-center>
      <v-btn
        data-cy="btn-sign-and-continue-physical-signature"
        :key="buttonKey"
        :disabled="!signedDocs || loading"
        :loading="loading"
        class="btn-primary"
        text
        @click.once="signAndContinue">
        {{ $t('buttons.next') }}
      </v-btn>
    </template>
  </mapit-dialog>
</template>

<script lang="ts">
import Vue from 'vue'

import MapitDialog from '@/components/dialog/MapitDialog.vue'
import {Product} from '@/types/dynamodb-types'

type BaseData = {
  signedDocs: boolean
  buttonKey: number
}

export default Vue.extend({
  name: 'UploadRegistrationDocsDialog',
  components: {
    MapitDialog,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    contracts: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data(): BaseData {
    return {
      signedDocs: false,
      buttonKey: 1,
    }
  },
  computed: {
    contractHP(): any {
      return this.contracts.find(
        (contract: any) => contract.name === Product.HondaPlus && Object.hasOwn(contract, 's3Key'),
      )
    },
    contractSEPA(): any {
      return this.contracts.find((contract: any) => contract.name === 'SEPA' && Object.hasOwn(contract, 's3Key'))
    },
    contractHM(): any {
      return this.contracts.find(
        (contract: any) => contract.name === Product.HondaMapit && Object.hasOwn(contract, 's3Key'),
      )
    },
  },
  methods: {
    signAndContinue() {
      if (this.signedDocs) {
        this.signedDocs = false
        this.$emit('continue')
      }
      this.buttonKey++
    },
    close() {
      this.signedDocs = false
      this.$emit('close')
    },
  },
})
</script>

<style lang="scss">
#check-signed i.success--text {
  color: var(--v-primary-base) !important;
  caret-color: var(--v-primary-base) !important;
}

.title-print-and-upload {
  letter-spacing: 0px;
  text-align: center;
  font-size: 24px;
  font-family: 'ProximaNovaExCnSBold', sans-serif;
  color: var(--v-gray-darken4);
  text-transform: uppercase;
  opacity: 1;

  i {
    color: var(--v-gray-lighten3) !important;
  }
}

.subtitle-print-and-upload {
  font-family: 'ProximaNovaRegular', sans-serif;
  font-size: 15px;
  letter-spacing: 0px;
  text-align: center;
  color: var(--v-gray-darken4);
  opacity: 1;

  .check-signed {
    width: fit-content;
  }

  .theme--light.v-label {
    color: #000000 !important;
  }
}
</style>
